import { getNbaQuery, getTreatmentsQuery, setNbaEventQuery } from '../graphql/queries/multibss/guru.query';
import { ApiResponse, query } from './api';
import { Nba, Treatment } from './guru.types';

interface GuruInterface {
  getNba(email: string, customerNumber: string, pageId: string, treatmentIds?: string[]): ApiResponse<Nba[]>;
  setNbaEvent(
    customerNumber: string,
    pageId: string,
    interactionId: string,
    treatmentId: string,
    propositionId: string
  ): ApiResponse<{ success: boolean }>;
  getTreatments(email: string, customerNumber: string, pageId: string): Promise<Treatment[]>;
}

export const GuruApi: GuruInterface = {
  async getNba(email: string, customerNumber: string, pageId: string, treatmentIds?: string[]) {
    return query<{ getNbaList: Nba[] }>({
      query: getNbaQuery,
      variables: { email, customerNumber, pageId, treatmentIds },
      name: 'getNbaList',
    }).then(({ getNbaList }) => ({ data: getNbaList }));
  },
  async getTreatments(email: string, customerNumber: string, pageId: string): Promise<Treatment[]> {
    const response = await query<{ getTreatments: Treatment[] }>({
      query: getTreatmentsQuery,
      variables: { email, customerNumber, pageId },
      name: 'getTreatments',
    });

    return response.getTreatments || [];
  },
  async setNbaEvent(
    customerNumber: string,
    pageId: string,
    interactionId: string,
    treatmentId: string,
    propositionId: string
  ) {
    return query<{ setNbaEvent: { success: boolean } }>({
      query: setNbaEventQuery,
      variables: { customerNumber, pageId, treatmentId, interactionId, propositionId },
      name: 'setNbaEvent',
    }).then(({ setNbaEvent }) => ({ data: setNbaEvent }));
  },
};
